import { AkixiWindow } from './Types/Types'

export const $window: AkixiWindow = window as AkixiWindow
// eslint-disable-next-line
export const $akixi: any = $window.com.Akixi
